<template>
  <div>
    <p class="img"><img src="../assets/xinjian.png" alt="" srcset="" /></p>
    <p>
      感谢您的来信，请记住您的信件查询码。您可以 在“<a
        href="https://zld.zjzwfw.gov.cn/zjservice/xinfang/query.do"
        target="_blank"
        rel="noopener noreferrer"
        >我要查询</a
      >”栏目中，通过查询码查询该信件的受理情况。
    </p>
    <p>
      查询码：<span style="color:#0081ff">{{ $route.query.cxm }}</span>
    </p>
    <p class="tips">
      温馨提示：请妥善保管您的信件查询码，以便及时获取信件的最新受理情况。
    </p>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #0081ff;
}
div {
  width: 1100px;
  margin: 0 auto;
}
.img {
  margin-top: 5rem;
  text-align: center;
}
.tips {
  color: #ccc;
  margin-top: 2rem;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue